import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '@app/utils/date';

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  /**
   * Input the number of milliseconds and get the string output such as '2h 35m 4s'
   *
   * @param value Milliseconds
   */
  transform(value: any): any {
    return DateUtils.formatAsDuration(value);
  }
}
